<template>
  <b-row>
    <b-col :lg="!state.system.isOffline ? '6' : '10'" md="6" sm="6">
      <b-row>
        <b-col md="12" lg="12" class="cust-summary-dark">
          <p class="mb-0">Personal Information</p>
          <hr />
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0">Phone Number</label>
          <p class="mb-0" v-text="customerDetails.data.mobile"></p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">Customer Name</label>
          <p
            :class="
              customerDetails.data.first_name == '' &&
              customerDetails.data.last_name == ''
                ? 'mb-0 text-muted'
                : 'mb-0'
            "
            v-text="
              customerDetails.data.first_name == '' &&
              customerDetails.data.last_name == ''
                ? 'Not Specified'
                : customerDetails.data.first_name +
                  ' ' +
                  customerDetails.data.last_name
            "
          ></p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0">E-mail Address</label>
          <p
            :class="
              customerDetails.data.email == '' ? 'mb-0 text-muted' : 'mb-0'
            "
            v-text="
              customerDetails.data.email == ''
                ? 'Not Specified'
                : customerDetails.data.email
            "
          ></p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0">Gender</label>
          <p
            :class="
              customerDetails.data.gender == '' ? 'mb-0 text-muted' : 'mb-0'
            "
            v-text="
              customerDetails.data.gender == ''
                ? 'Not Specified'
                : customerDetails.data.gender
            "
          ></p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">Date of Birth</label>
          <p
            class="mb-0 text-muted"
            v-if="
              customerDetails.data.dob == '' ||
                customerDetails.data.dob == 'Invalid date'
            "
          >
            Not Specified
          </p>
          <p class="mb-0" v-else>
            {{ $moment(customerDetails.data.dob).format("Do MMM YYYY") }}
          </p>
        </b-col>
        <b-col md="12" lg="12" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">GSTIN Information</label>
          <!-- <p>Cassian Andor Pvt.Ltd &nbsp; &nbsp; Uttar Pradesh &nbsp; &nbsp;{{customerDetails.data.gstin}}</p> -->
          <p
            :class="
              customerDetails.data.gstin == '' ? 'mb-0 text-muted' : 'mb-0'
            "
            v-text="
              customerDetails.data.gstin == ''
                ? 'Not Specified'
                : customerDetails.data.gstin
            "
          ></p>
        </b-col>
        <b-col md="12" lg="12" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">Address</label>
          <p
            :class="{
              'text-muted': getAddress == 'Not Specified',
              'mb-0': true,
            }"
            v-text="getAddress"
          />
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">Landmark</label>
          <p
            :class="
              customerDetails.address == null ||
              customerDetails.address.landmark == ''
                ? 'mb-0 text-muted'
                : 'mb-0'
            "
            v-text="
              customerDetails.address == null ||
              customerDetails.address.landmark == ''
                ? 'Not Specified'
                : customerDetails.address.landmark
            "
          ></p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">Pincode</label>
          <p
            :class="
              customerDetails.address == null ||
              customerDetails.address.pincode == ''
                ? 'mb-0 text-muted'
                : 'mb-0'
            "
            v-text="
              customerDetails.address == null ||
              customerDetails.address.pincode == ''
                ? 'Not Specified'
                : customerDetails.address.pincode
            "
          ></p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">City</label>
          <p
            class="mb-0 text-muted"
            v-if="
              customerDetails.address.city_name == '' ||
                customerDetails.address.city_name == 'Select City'
            "
          >
            Not Specified
          </p>
          <p class="mb-0" v-else>
            {{
              customerDetails.address == null
                ? ""
                : customerDetails.address.city_name
            }}
          </p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-0 fs-12">State</label>
          <p
            class="text-muted mb-0"
            v-if="
              customerDetails.address.state_name == '' ||
                customerDetails.address.state_name == 'Select State'
            "
          >
            Not Specified
          </p>
          <p class="mb-0" v-else>
            {{
              customerDetails.address == null
                ? ""
                : customerDetails.address.state_name
            }}
          </p>
        </b-col>
        <b-col md="12" lg="12" class="cust-summary-dark mb-3">
          <label class="mb-0 pl-1">Groups assigned ({{ groupSize }})</label>
          <hr />
          <div class="d-flex">
            <div v-for="group in groups" :key="group.id">
              <b-badge class="font-normal mr-2 px-2 py-2">{{ group }}</b-badge>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col
      lg="4"
      md="4"
      sm="4"
      class="account-detail"
      v-if="state.system.isOffline == false"
    >
      <b-row>
        <b-col md="12" lg="12" class="cust-summary-dark">
          <p class="mb-0">Account</p>
          <hr />
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p>
            <b>Amount Due</b>
          </p>
        </b-col>
        <b-col md="6" lg="6">
          <p
            class="float-right"
            :style="
              parseFloat(customerDetails.summary.amount_due) < 0
                ? 'color: red;'
                : ''
            "
          >
            <b
              v-text="
                currencySymbol +
                  formatAmount(customerDetails.summary.amount_due)
              "
            />
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Available On-Account Limit</p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="
              currencySymbol + formatAmount(customerDetails.summary.max_limit)
            "
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Total spent till date</p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="
              currencySymbol + formatAmount(customerDetails.summary.total_spent)
            "
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Total bills till date</p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="formatText(customerDetails.summary.no_of_bills)"
          />
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Completed sales</p>
        </b-col>
        <b-col md="2" lg="2" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="formatText(customerDetails.summary.compleleted_sales_total)"
          />
        </b-col>
        <b-col md="4" lg="4" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="
              currencySymbol +
                formatAmount(customerDetails.summary.compleleted_sales)
            "
          />
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Lay-by</p>
        </b-col>
        <b-col md="2" lg="2" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="customerDetails.summary.layby_count"
          ></p>
        </b-col>
        <b-col md="4" lg="4" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="currencySymbol + customerDetails.summary.layby"
          ></p>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">On-account</p>
        </b-col>
        <b-col md="2" lg="2" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="formatText(customerDetails.summary.no_of_on_account)"
          />
        </b-col>
        <b-col md="4" lg="4" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="
              currencySymbol + formatAmount(customerDetails.summary.on_account)
            "
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Returns</p>
        </b-col>
        <b-col md="2" lg="2" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="formatText(customerDetails.summary.no_of_returns)"
          />
        </b-col>
        <b-col md="4" lg="4" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="
              currencySymbol +
                formatAmount(customerDetails.summary.total_returns)
            "
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class>
            <b>Loyalty</b>
          </p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="float-right">
            <b
              v-text="
                currencySymbol + formatAmount(customerDetails.summary.loyalty)
              "
            />
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Loyalty earned</p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="
              currencySymbol + formatAmount(customerDetails.summary.loyalty)
            "
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-0">Loyalty redeemed</p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p
            class="float-right mb-0"
            v-text="
              currencySymbol + formatAmount(customerDetails.summary.loyalty)
            "
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class>
            <b>Store Credit</b>
          </p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="float-right">
            <b
              v-text="
                currencySymbol +
                  formatAmount(customerDetails.summary.total_store_credit)
              "
            />
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Store credit issued</p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="float-right mb-1">
            <b
              v-text="
                currencySymbol +
                  formatAmount(customerDetails.summary.store_credit_unused)
              "
            ></b>
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p class="mb-1">Store credit redeemed</p>
        </b-col>
        <b-col md="6" lg="6" class="cust-summary-dark">
          <p
            class="float-right mb-1"
            v-text="
              currencySymbol +
                formatAmount(customerDetails.summary.store_credit_used)
            "
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col lg="2" md="2" sm="3">
      <p class="text-center">Actions</p>

      <b-button
        class="w-100 mb-3"
        variant="primary"
        @click="showDebitNote(), (totalPayAmount = '0.00')"
        v-if="type == 'profile'"
        :disabled="checkOnAccountSale || $loading"
        title="Pay Balance"
      >
        <span v-if="!$loading || btnName != 'paybalance'">Pay Balance</span>
        <b-spinner small v-if="$loading && btnName == 'paybalance'" />
      </b-button>
      <b-button
        class="w-100 mb-3"
        disabled
        v-if="type == 'profile'"
        id="invoice-history"
        >Invoice History</b-button
      >
      <b-button
        class="w-100 mb-3"
        :disabled="$loading"
        @click="showCustInformation"
        title="Edit Information"
        id="edit-information"
        >Edit Information</b-button
      >
      <b-button
        class="w-100 mb-3"
        @click="getGstList"
        :disabled="$loading"
        v-if="type == 'profile'"
        title="Manage GSTIN"
        id="manage-gstin"
        >Manage GSTIN</b-button
      >
      <b-button
        class="w-100 mb-3"
        :disabled="$loading || state.system.isOffline"
        @click="openCloseGroup = true"
        v-if="
          state.system.settings.vendor_login_details.c_id !=
            customerDetails.data.c_id
        "
        title="Edit Groups"
        id="edit-groups"
        >Edit Groups</b-button
      >
      <b-button
        class="w-100 mb-3"
        disabled
        v-if="type == 'profile'"
        title="Loyalty"
        id="loyalty"
        >Loyalty</b-button
      >
      <b-button
        class="primary-btn w-100 mb-3"
        title="Store Credit Notes"
        v-if="type == 'profile'"
        id="issue-credit-voucher"
        @click="openIssueCredit = true"
        :disabled="$loading"
        >Store Credit Notes</b-button
      >
      <b-button
        variant="danger"
        class="w-100 mb-3"
        @click="unTagCustomer"
        v-if="type == 'login'"
        :disabled="$loading"
        title="Untag Customer"
        id="untag-customer"
        >Untag Customer</b-button
      >
      <div v-if="checkIfGv">
        <p class="text-center mt-3">Voucher(s)</p>
        <b-button
          variant="primary"
          class="w-100 mb-3"
          :disabled="$loading || checkVoucherInCart"
          title="Add to all"
          @click="gvCustomerTagging('tag_cart')"
          >Add to all</b-button
        >
        <b-button
          variant="danger"
          class="w-100"
          :disabled="$loading || checkVoucherInCart"
          title="Remove from all"
          @click="gvCustomerTagging('remove_cart')"
          >Remove from all</b-button
        >
      </div>
    </b-col>

    <!-- Cust-Info Update Modal -->
    <b-modal
      ref="cust-information"
      hide-footer
      centered
      title="Customer Information"
      size="lg"
      no-close-on-backdrop
      @hide="$emit('get-profile')"
    >
      <b-form v-on:submit.prevent id="billing-modal">
        <b-row>
          <b-col lg="6" md="6">
            <b-form-group
              id="input-group-1"
              label="Customer Phone Number"
              label-for="Cust-Phone"
            >
              <b-form-input
                id="Cust-Phone"
                name="Cust-Phone"
                placeholder="Enter Phone No."
                v-model="customerDetails.data.mobile"
                autofocus
                autocomplete="off"
                style="border: none"
                disabled
              />

              <b-form-invalid-feedback id="phone-live-feedback">
                Phone number must be
                {{ state.system.country_details.phone_digit }} characters long.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-row v-if="customerDetails != ''">
              <b-form-group id="custEmail" class="col-md-12">
                <label for="custEmail"
                  >Customer Email Address
                  <span v-show="requiredFields.email" class="text-danger"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="custEmail"
                  v-model="$v.customerDetails.data.email.$model"
                  type="email"
                  autocomplete="off"
                  :state="
                    $v.customerDetails.data.email.$dirty
                      ? !$v.customerDetails.data.email.$error
                      : null
                  "
                  placeholder="username@mail.com"
                  aria-describedby="email-live-feedback"
                  :disabled="$loading"
                />
                <b-form-invalid-feedback id="email-live-feedback"
                  >Enter a valid email address.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group id="DOB" class="col-md-12">
                <label for="DOB"
                  >Date of Birth
                  <span
                    v-show="requiredFields.date_of_birth"
                    class="text-danger"
                    >*</span
                  ></label
                >
                <datepicker
                  placeholder="Select..."
                  input-class="form-control"
                  v-model="customerDetails.data.dob"
                  id="date_of_birth"
                />
              </b-form-group>

              <b-form-group id="custAddress" class="col-md-12">
                <label for="address"
                  >Customer Address
                  <span class="text-danger" v-show="requiredFields.address"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="custAddress"
                  v-model.trim="customerDetails.address.address1"
                  type="text"
                  autocomplete="off"
                  placeholder="Address Line 1"
                  :disabled="$loading"
                />
              </b-form-group>

              <b-form-group
                id="landmark"
                label="Landmark"
                label-for="landmark"
                class="col-md-12"
              >
                <b-form-input
                  type="text"
                  class
                  autocomplete="off"
                  placeholder="Add Landmark"
                  :disabled="$loading || state.system.isOffline"
                  v-model="customerDetails.address.landmark"
                  id="input-landmark"
                />
              </b-form-group>

              <b-form-group
                id="custState"
                class="col-md-12"
                label="State"
                label-for="state"
              >
                <b-form-select
                  v-model="customerDetails.address.state_id"
                  @change="cityList('change')"
                  style="cursor: pointer"
                  id="select-state"
                >
                  <option value selected disabled>Select State</option>
                  <option
                    v-for="sort in states"
                    :value="sort.id"
                    v-text="sort.name"
                    :key="sort.id"
                    :id="sort.name"
                  />
                </b-form-select>
              </b-form-group>
            </b-row>
          </b-col>

          <b-col lg="6" md="6" v-if="customerDetails != ''">
            <b-row>
              <b-form-group id="Customer-Name" class="col-md-6">
                <label for="Customer-Name"
                  >Customer First Name
                  <span v-show="requiredFields.first_name" class="text-danger"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="Customer-Name-input"
                  v-model="customerDetails.data.first_name"
                  type="text"
                  autocomplete="off"
                  placeholder="Customer First Name"
                  :disabled="$loading"
                />
              </b-form-group>
              <b-form-group id="Customer-Name-2" class="col-md-6">
                <label for="Customer-Name"
                  >Customer Last Name
                  <span v-show="requiredFields.last_name" class="text-danger"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="Customer-Name-input-2"
                  v-model="customerDetails.data.last_name"
                  type="text"
                  autocomplete="off"
                  placeholder="Customer Last Name"
                  :disabled="$loading"
                />
              </b-form-group>
            </b-row>

            <b-form-group id="gender">
              <label for="gender"
                >Gender
                <span v-show="requiredFields.gender" class="text-danger"
                  >*</span
                ></label
              >
              <b-form-select
                v-model="customerDetails.data.gender"
                class="form-control"
                style="cursor: pointer"
                id="select-gender"
              >
                <option value="">Select Gender</option>
                <option value="Male" selected id="male">Male</option>
                <option value="Female" id="female">Female</option>
              </b-form-select>
            </b-form-group>

            <b-form-group
              id="custGST"
              label="GST Identification Number"
              label-for="custGST"
              style="visibility: hidden"
            >
              <b-form-input
                id="custGST"
                v-model="customerDetails.data.gstin"
                type="text"
                placeholder="Enter GSTIN for B2B Billing"
                autocomplete="off"
                :disabled="$loading"
                style="visibility: hidden"
              />
            </b-form-group>

            <b-form-group
              id="custAddress2"
              label-for="custAddress2"
              label="Address Line 2"
            >
              <b-form-input
                id="custAddress2"
                v-model="customerDetails.address.address2"
                type="text"
                autocomplete="off"
                placeholder="Address Line 2"
                :disabled="$loading || state.system.isOffline"
              />
            </b-form-group>

            <b-form-group id="custPin" label-for="custPin" label="Pincode">
              <b-form-input
                id="custPin"
                v-model="customerDetails.address.pincode"
                type="text"
                placeholder="Pincode"
                :disabled="$loading || state.system.isOffline"
              />
            </b-form-group>

            <b-form-group id="custCity" label-for="custCity" label="City">
              <b-form-select
                v-model="customerDetails.address.city_id"
                :disabled="cities == ''"
                style="cursor: pointer"
                id="select-city"
              >
                <option value selected disabled>Select City</option>
                <option
                  v-for="sort in cities"
                  :value="sort.id"
                  v-text="sort.name"
                  :key="sort.id"
                  :id="sort.name"
                />
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="text-right">
          <b-button
            style="margin-left: 10px"
            class="grey-btn"
            variant="secondary"
            type="button"
            :disabled="$v.customerDetails.$invalid || $loading"
            @click="saveUserDetails"
            v-shortkey="['enter']"
            @shortkey="saveUserDetails"
            id="update-details"
          >
            <span v-if="!$loading">Update</span>
            <b-spinner small v-if="$loading" />
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Create new credit note modal-->
    <b-modal
      ref="new-credit-note"
      id="new-credit-note"
      hide-footer
      centered
      size="sm"
      title="New Credit Note"
      no-close-on-backdrop
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            id="amount"
            label="Credit Note Amount"
            label-for="amount"
            class="mb-2"
          >
            <b-form-input
              id="amount"
              type="number"
              placeholder="Enter credit note amount"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="datepicker"
            label="Valid till"
            label-for="datepicker"
            class="creditnote-datepicker"
          >
            <b-input-group>
              <template v-slot:append>
                <b-input-group-text
                  ><font-awesome-icon :icon="['fa', 'calendar-alt']"
                /></b-input-group-text>
              </template>
              <datepicker
                id="datepicker"
                input-class="form-control w-100"
                v-model="date"
              ></datepicker>
            </b-input-group>
          </b-form-group>
          <b-form-group
            id="remark"
            label="Remark"
            label-for="remark"
            class="mb-2"
          >
            <b-form-textarea
              id="remark"
              placeholder="Add remark..."
              rows="3"
            ></b-form-textarea>
          </b-form-group>

          <b-row class="mt-4">
            <b-col md="6">
              <b-button
                class="grey-btn w-100"
                variant="secondary"
                type="button"
                @click="$bvModal.hide('new-credit-note')"
              >
                Cancel
              </b-button>
            </b-col>
            <b-col md="6">
              <b-button class="blue-btn w-100" variant="primary" disabled>
                <span v-if="$loading == false">Continue </span>
                <b-spinner small v-if="$loading == true"></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- store credit refund modal-->
    <b-modal
      ref="store-credit"
      id="store-credit"
      hide-footer
      centered
      size="xl"
      :title="debitNoteTitle"
      no-close-on-backdrop
    >
      <b-row>
        <b-col md="12" v-if="creditNotes.length > 0">
          <ul class="batch-header py-2 credit-list list-inline fs-11 mb-0">
            <li>
              <span v-if="refundCredit == true"> #</span>
              <div v-else class="custom-check pt-0">
                <input
                  type="checkbox"
                  value="select_all"
                  id="select_all"
                  class="pt-0"
                  @click="selectAllDebitNotes"
                />
                <label for="select_all"></label>
              </div>
            </li>
            <li>Created on</li>
            <li>Valid Till</li>
            <li>Credit Note Number</li>
            <li>Type</li>
            <li>Remark / Reference Invoice Number</li>
            <li>Value</li>
            <li>Redeemed</li>
            <li>Balance</li>
          </ul>
          <ul
            v-for="(item, index) in creditNotes"
            :key="item.voucher_id"
            class="credit-list list-inline py-3 fs-12 mb-0"
          >
            <li>
              <span v-if="refundCredit == true"> {{ index + 1 }}</span>
              <div v-else class="custom-check pt-0">
                <input
                  type="checkbox"
                  :value="item.number"
                  :id="item.number"
                  :disabled="selectAllBoxes"
                  class="pt-0"
                  @click="getCreditNote(item)"
                />
                <label :for="item.number"></label>
              </div>
            </li>
            <li v-text="item.created"></li>
            <li v-text="item.valid"></li>
            <li v-text="item.number"></li>
            <li v-text="item.type"></li>
            <li v-text="item.remark"></li>
            <li
              v-text="currencySymbol + ' ' + parseFloat(item.value).toFixed(2)"
            ></li>
            <li
              :class="{ 'text-muted': item.redeemed == 0 }"
              v-text="
                currencySymbol + ' ' + parseFloat(item.redeemed).toFixed(2)
              "
            ></li>
            <li
              v-text="
                currencySymbol + ' ' + parseFloat(item.balance).toFixed(2)
              "
            ></li>
          </ul>
          <b-row class="mt-4" v-if="refundCredit == true">
            <b-col md="12" class="text-right">
              <b-button
                class="grey-btn"
                variant="secondary"
                type="button"
                @click="toggleRefundCredit()"
              >
                Refund Credit
              </b-button>
              <b-button
                class="blue-btn ml-2"
                variant="primary"
                @click="$bvModal.show('new-credit-note')"
              >
                New Credit Note
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-4" v-else>
            <b-col md="12" class="text-right">
              <b-button
                class="grey-btn"
                variant="secondary"
                type="button"
                @click="toggleRefundCredit()"
              >
                Cancel
              </b-button>
              <b-button
                class="blue-btn ml-2"
                variant="primary"
                @click="checkout"
                disabled
              >
                <span v-if="$loading == false"
                  >{{ currencySymbol }} Refund
                </span>
                <b-spinner small v-if="$loading == true"></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          md="12"
          v-else
          style="min-height: 150px"
          class="d-flex align-items-center justify-content-center"
        >
          <p>No credit note found!</p>
        </b-col>
      </b-row>
    </b-modal>

    <!--Debit note modal -->
    <b-modal
      ref="debit-note"
      hide-footer
      centered
      title="Select Debit Note(s)"
      :size="debitNotes.length > 0 ? 'xl' : 'sm'"
      no-close-on-backdrop
    >
      <b-row>
        <b-col md="3">
          <b-form-group
            id="payment"
            label="Payment to be collected"
            label-for="payment"
            class="mt-2 mb-3"
            v-if="debitNotes.length > 0"
          >
            <b-form-input
              id="payment"
              v-model="totalPayAmount"
              class="collected-payment"
              type="number"
              disabled
              autocomplete="off"
              :placeholder="currencySymbol + '0.00'"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" v-if="debitNotes.length > 0">
          <ul class="batch-header py-2 list-inline fs-11 mb-0">
            <li>
              <div class="custom-check">
                <input
                  type="checkbox"
                  value="select_all_checkbox"
                  id="select_all_checkbox"
                  @click="selectAllDebitNotes"
                />
                <label
                  for="select_all_checkbox"
                  id="label_select_all_checkbox"
                ></label>
              </div>
            </li>
            <li>Issued on</li>
            <li>Debit Note Number</li>
            <li>Reference Invoice</li>
            <li>Value</li>
            <li>Paid off</li>
            <li>Balance</li>
            <li>Payable Amount</li>
          </ul>
          <ul
            v-for="item in debitNotes"
            :key="item.voucher_id"
            :class="{
              hidden: selectedDebitNote[item.voucher_id].selected == false,
            }"
            class="list-inline py-2 fs-12 mb-0"
          >
            <li>
              <div class="custom-check">
                <input
                  type="checkbox"
                  :value="item.voucher_id"
                  :id="item.voucher_id"
                  @click="getDebitNote(item)"
                />
                <!-- :disabled="selectAllBoxes" -->
                <label :for="item.voucher_id"></label>
              </div>
            </li>
            <li>{{ $moment(item.date_of_issue).format("Do MMM YYYY") }}</li>
            <li v-text="item.doc_no"></li>
            <li v-text="item.trans_src_ref"></li>
            <li
              v-text="currencySymbol + parseFloat(item.value).toFixed(2)"
            ></li>
            <li
              :class="{ 'text-muted': item.prev_paid == 0 }"
              v-text="currencySymbol + parseFloat(item.prev_paid).toFixed(2)"
            ></li>
            <li
              v-text="currencySymbol + parseFloat(item.balance).toFixed(2)"
            ></li>
            <li>
              <b-form-input
                size="sm"
                autofocus
                type="number"
                class="w-100"
                v-model="selectedDebitNoteAmount[item.voucher_id]"
                :placeholder="currencySymbol + '0.00'"
                :disabled="!selectedDebitNote[item.voucher_id].selected"
                @input="getTotalPayAmount(item.voucher_id)"
                autocomplete="off"
                :id="'input-' + item.voucher_id"
              ></b-form-input>
            </li>
          </ul>
          <b-row class="mt-4">
            <b-col md="12" class="text-right">
              <b-button
                class="blue-btn"
                variant="primary"
                @click="checkout"
                :disabled="
                  checkoutBtn ||
                    checkoutBtnIfAmtEmpty ||
                    $loading ||
                    parseFloat(totalPayAmount) < 0 ||
                    parseFloat(totalPayAmount) == 0
                "
                id="proceed-to-checkout"
              >
                <span v-if="$loading == false">Proceed to Checkout</span>
                <b-spinner small v-if="$loading == true"></b-spinner>
              </b-button>
              <!-- :disabled="totalPayAmount == '0.00' || parseFloat(totalPayAmount) == 0 || checkoutBtn" -->
            </b-col>
          </b-row>
        </b-col>
        <b-col
          md="12"
          v-else
          style="min-height: 150px"
          class="d-flex align-items-center justify-content-center"
        >
          <p class="text-muted">No debit note found!</p>
        </b-col>
      </b-row>
    </b-modal>

    <add-gst-modal
      :open="openGst"
      :mobile="customerDetails.data.mobile"
      :type="'profile'"
      @closeGstModal="closeGst"
      :selected_gst="customerDetails.data.gstin"
    />
    <customer-group
      :open="openCloseGroup"
      :c_id="customerDetails.data.c_id"
      @close-group-modal="closeCustomerGroupModal"
    />
    <adhoc-credit-note
      :open="openIssueCredit"
      :customerDetails="customerDetails"
      @close-issue-credit="openIssueCredit = false"
      @open-issue-credit="openIssueCredit = true"
    />
  </b-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import Datepicker from "vuejs-datepicker";
import { email } from "vuelidate/lib/validators";
import moment from "moment";
import axios from "axios";
import { mapState } from "vuex";
import AddGstModal from "./AddGstModal";
import CustomerGroup from "./CustomerGroup";
import * as msg from "../message";
import AdhocCreditNote from "./AdhocCreditNote";

export default {
  name: "customer-dashboard",
  mixins: [validationMixin],
  props: ["custDetails", "type", "count"],
  components: { Datepicker, AddGstModal, CustomerGroup, AdhocCreditNote },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    getDataFromState() {
      return this.state.billing.billing.customer.data;
    },
    selectedDebitNote() {
      let data = {};
      this.getDebitNoteData.forEach((item) => {
        data[item.id] = {
          selected: item.selected,
          doc_no: item.doc_no,
          balance: item.paybale,
        };
      });
      return data;
    },
    checkOnAccountSale() {
      let check = true;
      if (
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .options[0].on_account_sale.value == "mandatory"
      )
        check = false;
      return check;
    },
    checkoutBtnIfAmtEmpty() {
      let check = false;

      // for (let key in this.selectedDebitNote) {
      //   if (
      //     this.selectedDebitNoteAmount[key] == "" &&
      //     this.selectedDebitNote[key].selected
      //   ) {
      //     check = true;
      //   } else if (
      //     this.selectedDebitNoteAmount[key] != "" &&
      //     this.selectedDebitNote[key].selected
      //   )
      //     check = false;
      // }

      // for (let key in this.selectedDebitNoteAmount) {
      //   console.log(this.selectedDebitNoteAmount[key]);
      // }
      return check;
    },
    debitNoteTitle() {
      if (this.refundCredit == true) {
        return "Store Credit Notes";
      } else {
        return "Select Credit Notes for Refund (0)";
      }
    },
    checkIfGv() {
      let temp = false;
      if (window.location.hash == "#/gift-vouchers") temp = true;
      return temp;
    },
    checkVoucherInCart() {
      let temp = true;
      if (this.state.giftVoucher.cart.cart_details.length > 0) temp = false;
      return temp;
    },
    states() {
      return this.state.extra.states;
    },
    getAddress() {
      let temp = "Not Specified";
      if (!this.checkEmpty(this.customerDetails.address.address1))
        temp = this.customerDetails.address.address1;
      if (!this.checkEmpty(this.customerDetails.address.address2))
        temp += ` ${this.customerDetails.address.address2}`;
      return temp;
    },
    requiredFields() {
      let data = this.state.system.settings.vendor_app_menu
        .customer_extra_information.options;
      let status =
        this.state.system.settings.vendor_app_menu.customer_extra_information
          .status == 1
          ? true
          : false;
      return {
        address: status && data.address.status,
        email: status && data.email.status,
        date_of_birth: status && data.date_of_birth.status,
        gender: status && data.gender.status,
        first_name: status && data.first_name.status,
        last_name: status && data.last_name.status,
      };
    },
    markedFields() {
      if (this.requiredFields.email && this.customerDetails.data.email == "")
        return false;
      if (
        this.requiredFields.first_name &&
        this.customerDetails.data.first_name == ""
      )
        return false;
      if (
        this.requiredFields.last_name &&
        this.customerDetails.data.last_name == ""
      )
        return false;
      if (
        this.requiredFields.address &&
        (this.customerDetails.address == null ||
          this.customerDetails.address.address1 == "")
      )
        return false;
      if (
        this.requiredFields.date_of_birth &&
        this.customerDetails.data.dob == ""
      )
        return false;
      if (this.requiredFields.gender && this.customerDetails.data.gender == "")
        return false;
      return true;
    },
  },
  data() {
    return {
      Title: "Customer Profile",
      hide: false,
      hideGroup: false,
      groupSize: 0,
      selected: "sales",
      openGst: false,
      cities: [],
      refundCredit: true,
      customerDetails: {
        data: {},
        address: {
          state_name: "Select State",
          city_name: "Select City",
          address1: "",
          address2: "",
          landmark: "",
          pincode: "",
          city_id: "",
          state_id: "",
        },
        summary: {},
      },
      groups: [],
      getDebitNoteData: [],
      btnName: "",
      debitNotes: [],
      totalPayAmount: 0.0,
      debitNoteError: {},
      selectedDebitNoteAmount: {},
      selectedCreditNoteAmount: {},
      checkoutBtn: true,
      date: "",
      selectAllBoxes: false,
      creditNotes: [],
      openCloseGroup: false,
      openIssueCredit: false,
    };
  },
  validations() {
    return {
      customerDetails: {
        data: {
          email: {
            email,
          },
        },
      },
    };
  },
  watch: {
    custDetails() {
      if (this.custDetails != "" && this.type == "profile") {
        this.customerDetails = this.custDetails;
        this.groups = this.customerDetails.data.groups;
        this.groupSize = this.customerDetails.data.groups.length;
      }
    },
    count() {
      this.loadData();
    },
  },
  created() {
    if (this.type == "login") {
      this.loadData();
    }
  },
  methods: {
    toggleRefundCredit() {
      if (this.refundCredit == false) {
        this.refundCredit = true;
      } else {
        this.refundCredit = false;
      }
    },
    selectAllDebitNotes(e) {
      let isChecked = e.srcElement.checked;
      this.selectAllBoxes = isChecked;
      for (let key in this.selectedDebitNote) {
        if (isChecked) {
          this.selectedDebitNote[key].selected = true;
          this.selectedDebitNoteAmount[key] = this.selectedDebitNote[
            key
          ].balance;
          this.debitNoteError[key] = false;
          document.getElementById(key).checked = true;
        } else {
          this.selectedDebitNote[key].selected = false;
          this.selectedDebitNoteAmount[key] = "";
          this.debitNoteError[key] = false;
          document.getElementById(key).checked = false;
        }
      }
      this.getDebitNoteData.forEach((item) => {
        if (isChecked) item.selected = true;
        else item.selected = false;
      });
      this.getTotalPayAmount("all");
    },
    getTotalPayAmount(id) {
      if (id != "all") {
        if (
          this.selectedDebitNoteAmount[id] > this.selectedDebitNote[id].balance
        ) {
          this.debitNoteError[id] = true;
          this.checkoutBtn = true;
          let alertData = {
            message: msg.AMT_GREATER,
            type: "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
          return;
        } else this.debitNoteError[id] = false;
      }

      let count = 0;

      for (let key in this.debitNoteError) {
        if (this.debitNoteError[key]) count++;
      }

      if (count == 0) this.checkoutBtn = false;
      else this.checkoutBtn = true;

      let total = 0.0;
      for (let key in this.selectedDebitNote) {
        if (this.selectedDebitNote[key].selected)
          if (this.selectedDebitNoteAmount[key] != "")
            total += parseFloat(this.selectedDebitNoteAmount[key]);
      }
      this.totalPayAmount = parseFloat(total).toFixed(2);
    },
    checkout() {
      this.$loading = true;
      let debit_trans = [];
      for (let key in this.selectedDebitNote) {
        if (this.selectedDebitNote[key].selected)
          if (this.selectedDebitNoteAmount[key] != "")
            debit_trans.push({
              amount: this.selectedDebitNoteAmount[key],
              voucher_id: key,
              doc_no: this.selectedDebitNote[key].doc_no,
            });
      }
      // if (debit_trans.length == 0) {
      //   let alertData = {
      //     message: "Please select a transaction before continuing",
      //     type: "danger",
      //   };
      //   this.$showAlert = true;
      //   this.$store.commit("notifications/showAlert", alertData);
      //   this.$loading = false;
      //   return;
      // }
      let postData = {
        amount: this.totalPayAmount,
        total: this.totalPayAmount,
        type: "account_deposite",
        debit_trans: JSON.stringify(debit_trans),
        user_id: this.customerDetails.data.c_id,
        mobile: this.customerDetails.data.mobile,
        url: "/process-to-payment",
      };
      let data = Object.assign(postData, this.essentialsData);
      this.$store
        .dispatch("billing/checkOut", data)
        .then((res) => {
          this.$loading = false;
          if (res.data.status == "proceed_to_payment") {
            this.$store.commit("billing/tagCustomerDetails", res.data.customer);
            this.$router.push("/checkout");
          } else if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    getDebitNote(data) {
      this.getDebitNoteData.forEach((item) => {
        if (item.id == data.voucher_id) {
          if (item.selected) {
            item.selected = false;
            this.selectedDebitNoteAmount[item.id] = "";
            this.getTotalPayAmount(item.id);
          } else {
            item.selected = true;
            this.selectedDebitNoteAmount[item.id] = data.paybale;
            this.getTotalPayAmount(item.id);
          }
        }
      });

      this.checkSelectAllStatus();
    },
    checkSelectAllStatus() {
      let count = 0;
      for (let key in this.selectedDebitNote) {
        if (this.selectedDebitNote[key].selected) count += 1;
        else count -= 1;
      }
      if (count == this.getDebitNoteData.length)
        document.getElementById("select_all_checkbox").checked = true;
      else document.getElementById("select_all_checkbox").checked = false;
    },
    getCreditNote(data) {
      this.creditNotes.forEach((item) => {
        if (item.id == data.number) {
          if (item.selected) {
            item.selected = false;
            this.selectedCreditNoteAmount[item.id] = "";
          } else {
            item.selected = true;
            this.selectedCreditNoteAmount[item.id] = data.number;
          }
        }
      });
    },
    loadData() {
      this.customerDetails.data = this.getDataFromState;
      this.customerDetails.summary = this.state.billing.billing.customer.summary;
      if (this.state.billing.billing.customer.address != null) {
        this.customerDetails.address = this.state.billing.billing.customer.address;
      }
      this.groups = this.state.billing.billing.customer.data.groups;
      // this.groups.push(this.state.billing.billing.customer.customer_group_code);
      this.groupSize = this.groups.length;
    },
    getGstList() {
      this.openGst = true;
    },
    closeGst() {
      this.openGst = false;
    },
    // addNewGroup() {
    //   this.hide = true;
    // },
    // addNewGroup() {
    //   this.hideGroup = true;
    // },
    unTagCustomer() {
      this.$emit("untag-customer");
    },
    cityList(where = "") {
      let data = {
        trans_from: "CLOUD_TAB_WEB",
        state_id: this.customerDetails.address.state_id,
        url: "/location/get-city",
      };

      axios.post(data.url, data).then((response) => {
        if (where == "change") this.customerDetails.address.city_id = "";
        this.cities = response.data.data;
      });
    },
    showCustInformation() {
      if (this.type == "profile") {
        this.customerDetails.data.gender = this.formatText(
          this.customerDetails.data.gender,
          ""
        );
        if (!this.checkEmpty(this.custDetails.address.state_id))
          this.cityList();
        this.$refs["cust-information"].show();
      } else if (this.type == "login") {
        this.$emit("showCustInformation", true);
      }
    },
    showDebitNote() {
      this.btnName = "paybalance";
      this.$loading = true;
      let postData = {
        user_id: this.customerDetails.data.c_id,
        url: "/account-sale/debit-purchase-list",
      };
      let data = Object.assign(postData, this.essentialsData);
      delete data.customer_group_code;
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          if (res.data.status == "success") {
            this.debitNotes = res.data.data;
            this.debitNotes.forEach((item) => {
              this.debitNoteError[item.voucher_id] = false;
              this.selectedDebitNoteAmount[item.voucher_id] = "";
              this.getDebitNoteData.push({
                id: item.voucher_id,
                selected: false,
                doc_no: item.doc_no,
                balance: item.balance,
                paybale: item.paybale,
              });
            });
            this.$refs["debit-note"].show();
          } else if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
        })
        .catch(() => (this.$loading = false));
    },
    saveUserDetails() {
      if (!this.markedFields) {
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", {
          message: msg.FIELDS_COMP,
          type: "danger",
        });
        return;
      }
      if (this.$loading) return;
      let cust_dob = document.getElementById("date_of_birth").value;
      this.$loading = true;
      let old_c_id = "";
      let update_flag = 1;
      let data = Object.assign(
        {
          mobile: this.state.sessions.user.mobile,
          customer_mobile: this.customerDetails.data.mobile,
          first_name: this.customerDetails.data.first_name,
          last_name: this.customerDetails.data.last_name,
          email: this.customerDetails.data.email,
          dob:
            cust_dob == ""
              ? ""
              : moment(this.customerDetails.data.dob).format("DD-MM-YYYY"),
          gstin: this.customerDetails.data.gstin,
          gender: this.customerDetails.data.gender,
          address1: this.customerDetails.address.address1,
          address2: this.customerDetails.address.address2,
          pincode: this.customerDetails.address.pincode,
          state_id: this.customerDetails.address.state_id,
          city_id: this.customerDetails.address.city_id,
          landmark: this.customerDetails.address.landmark,
          hall_no: "",
          seat_no: "",
          update_flag: update_flag,
          url: "/vendor/login-for-customer",
          old_c_id: old_c_id,
        },
        this.essentialsData
      );
      axios
        .post(data.url, data)
        .then(() => {
          this.$refs["cust-information"].hide();
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    closeCustomerGroupModal(data) {
      this.openCloseGroup = false;
      this.groups = ["REGULAR"];
      data.forEach((item) => {
        if (item.selected) this.groups.push(item.name.toUpperCase());
      });
      this.groupSize = this.groups.length;
      if (this.type == "login") {
        this.$store.commit("billing/updateCusotmerGroup", this.groups);
      }
    },
    gvCustomerTagging(action_type) {
      this.$loading = true;
      this.$store
        .dispatch("giftVoucher/tagCustomerToGv", {
          action_type: action_type,
          customer_mobile: this.state.billing.billing.customer.data.mobile,
          gv_group_id: 0,
        })
        .then((res) => {
          this.$loading = false;
          if (res.data.status != "fail") {
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message:
                action_type == "tag_cart"
                  ? msg.VOUCHER_MOBILE_TAG
                  : msg.VOUCHER_MOBILE_UNTAG,
              type: "success",
            });
            this.$emit("hideDash");
          }
        })
        .catch(() => (this.$loading = false));
    },
  },
};
</script>

<style scoped lang="scss">
.cust-detail p {
  margin-bottom: revert;
}
.green-color {
  color: $green-color !important;
}
.gst-header {
  color: $dark-card-text;
  font-size: 11px;
}
.add-group-field {
  input {
    background: none;
    border: solid 2px #e0e0e0 !important;
    border-right: 0 !important;
  }
  .input-group-text {
    background: transparent;
    border-left: 0 !important;
    border: solid 2px #e0e0e0;
  }
}

.add-new {
  color: #808080;
}

.light-grey {
  color: #e0e0e0;
}
.blue-btn {
  background: $blue-color !important;
  border-color: $blue-color;
  &:hover {
    opacity: 0.5;
    border-color: $blue-color;
  }
}

.cash-register-data {
  h5 {
    color: $white-color;
  }
  .group-listing {
    color: #808080;
    .row.selected {
      background: #101010;
      border-radius: 3px;
    }
  }
  .gst-header {
    color: #606060;
  }
}

.customer-info {
  .badge {
    font-weight: normal;
    background: $light-grey;
    color: $body-color;
    width: 130px;
    font-size: 12px;
    @include text-overflow();
  }
}

// .btn-success.disabled,
// .btn-success:disabled {
//   background: #808080;
//   border-color: #808080;
// }

.custom-select {
  font-size: 13px;
}
.customer-data {
  height: calc(100vh - 90px);
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: -15px;
  margin-right: -15px;
  @include custom-scrollbar();
}

.group-listing {
  color: #808080;
  .row.selected {
    background: #f0f0f0;
    border-radius: 3px;
  }
}
.modal-body {
  label {
    font-size: 13px;
    margin-bottom: 0%;
  }
}
.batch-header {
  background: $dark-card-title-header;
}

.credit-list {
  &.list-inline {
    li {
      &:nth-child(1) {
        width: 5%;
        text-align: center;
      }
      &:nth-child(2) {
        width: 9%;
      }
      &:nth-child(3) {
        width: 9%;
      }
      &:nth-child(4) {
        width: 14%;
      }
      &:nth-child(5) {
        width: 8%;
      }
      &:nth-child(6) {
        width: 30%;
      }
      &:nth-child(7) {
        width: 8%;
      }
      &:nth-child(8) {
        width: 8%;
      }
      &:nth-child(8) {
        width: 8%;
      }
      &:nth-child(8) {
        width: 8%;
      }
    }
  }
}

.list-inline {
  color: #606060;
  &.hidden {
    opacity: 0.5;
  }
  li {
    &:nth-child(1) {
      width: 7%;
      text-align: center;
    }
    &:nth-child(2) {
      width: 14%;
    }
    &:nth-child(3) {
      width: 18%;
    }
    &:nth-child(4) {
      width: 18%;
    }
    &:nth-child(5) {
      width: 9%;
    }
    &:nth-child(6) {
      width: 9%;
    }
    &:nth-child(7) {
      width: 10%;
    }
    &:nth-child(8) {
      width: 15%;
    }
    .icon {
      cursor: pointer;
    }
    .icon {
      &.collapsed {
        transform: rotate(180deg);
      }
    }
  }
}
.collected-payment {
  &.form-control {
    &:disabled {
      background: transparent;
      border: 1px solid $dark-card-text !important;
    }
  }
}

.theme-dark {
  .cust-summary-dark {
    label {
      color: #808080;
    }
  }
  .badge {
    background: #404040;
    color: $white-color;
  }
  .account-detail {
    p {
      b {
        color: #fff;
      }
    }
    .cust-summary-dark {
      p {
        color: #a0a0a0;
      }
    }
  }
}
.theme-light {
  .account-detail {
    .cust-summary-dark {
      p {
        color: #808080;
      }
    }
  }
  .cust-detail {
    b {
      color: #404040;
    }
  }
}
</style>
